import { Component } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomerType } from 'src/app/enums/customer-type';
import { IWizard } from 'src/app/interfaces/iwizard';
import { WizardSteps } from 'src/app/interfaces/wizard-steps';
import { EnrollmentService } from 'src/app/services/enrollment.service';
import { GeneralService } from 'src/app/services/general.service';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-o-cert',
    templateUrl: './o-cert.component.html',
    styleUrls: ['./o-cert.component.scss'],
    standalone: false
})
export class OCERTComponent {
     htmlData:SafeHtml | null =  null;
     isLoading = true;

     constructor(public generalService: GeneralService,
          public enrollmentService: EnrollmentService,private sanitizer: DomSanitizer) {
     }

     wizardObj: IWizard = {
          steps: [
               { step: 1, text: 'Welcome' } as WizardSteps,
               { step: 2, text: 'Company Information' } as WizardSteps,
               { step: 3, text: 'User Accounts' } as WizardSteps,
               { step: 4, text: 'Review' } as WizardSteps,
               { step: 5, text: 'Contract Documents' } as WizardSteps,
               { step: 6, text: 'Submit' } as WizardSteps,
               { step: 7, text: 'Billing Information' } as WizardSteps
          ], 
          _cancelLinkRoute: '',
          backLinkRoute(currentPane: number) {;
            // not implimented
            return '';
          },
          continueLinkRoute(currentPane: number) {;
            // not implimented
            return '';
          },
          totalSteps: 1,
          type: 'enroll',
          visualProgressStep(currentPane: number) {;
            // not implimented
            return 1;
          }
     }

     ngOnInit(): void {
          const genService = this.generalService.getFile('Certifications');
          genService.toPromise().then((v: any) => {
               this.htmlData = this.sanitizer.bypassSecurityTrustHtml(v)
          });
          
          setTimeout(() => this.scrollToTop(), 500);
          this.isLoading = false;
     }

     get loadFile() {
          if (this.htmlData != null) {
               return this.htmlData;
          }
          return '';
     }

     ngAfterViewInit() {
          window.onbeforeunload = function () {
               return 'You have created an account but not set up billing. Are you sure you wish to exit?';
          }
     }

      pageValid(){
          return this.enrollmentService.newCustomer!.eulaAgreement!.readCerts.toString() === 'agree';
      }

     scrollToTop() {
          window.scrollTo(0, 0);
     }

     ngOnDestroy() {
          this.enrollmentService.saveToLocal();
     }
}
